import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Grid3x3,
  Activity,
  CheckSquare,
  MessageSquare,
  FileText,
  Bell,
  Gift,
} from 'lucide-react';

const TABS = [
  // { path: '/dashboard', label: 'Overview', icon: LayoutDashboard, exact: true },
  // { path: '/dashboard/services', label: 'All Services', icon: Grid3x3 },
  { path: '/dashboard/track', label: 'Track Services', icon: Activity },
  { path: '/dashboard/tasks', label: 'My Tasks', icon: CheckSquare },
  { path: '/dashboard/messages', label: 'Messages', icon: MessageSquare },
  { path: '/dashboard/documents', label: 'Documents', icon: FileText },
  // { path: '/dashboard/notifications', label: 'Notifications', icon: Bell },
  { path: '/dashboard/offers', label: 'Offers', icon: Gift, special: true },
];

export default function DashboardSubHeader() {
  const location = useLocation();

  return (
    <nav className="bg-white border-b border-gray-100 sticky top-[60px] z-20 shadow-sm">
      <div className="px-4 lg:px-8">
        <div className="flex items-center  flex-wrap gap-4 py-4">
          {TABS.map(tab => {
            const Icon = tab.icon;
            const isActive = tab.exact
              ? location.pathname === tab.path
              : location.pathname.startsWith(tab.path);

            if (tab.special) {
              return (
                <Link
                  key={tab.path}
                  to={tab.path}
                  className="flex items-center gap-2 px-7 py-2.5 text-sm font-bold whitespace-nowrap rounded-full bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white transition-all duration-200 shadow-lg hover:shadow-xl border border-pink-400 hover:border-pink-500 transform hover:scale-105"
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span className="tracking-wide">{tab.label}</span>
                </Link>
              );
            }

            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={`flex items-center gap-2 px-4 py-2 text-sm font-medium whitespace-nowrap rounded-lg transition-all duration-150 ${
                  isActive
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span>{tab.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
